
const nullCallback = () => null;
const trackMixpanel = (data) => {
  if (
    typeof window.mixpanel.identify === 'function' &&
    typeof window.mixpanel.track === 'function' &&
    typeof window.mixpanel.people === 'object'
  ) {
    const mixpanelData = Object.assign({}, {
      category: data.category,
      action: data.action,
    });

    if (data.sessionId) {
      if (typeof window.mixpanel.get_distinct_id === 'function' && (!window.COOKIE.get('alias') || window.COOKIE.get('alias') !== window.mixpanel.get_distinct_id())) {
        window.mixpanel.reset();
        window.COOKIE.set('alias', window.mixpanel.get_distinct_id());
      }

      window.mixpanel.identify(window.COOKIE.get('alias'));
      window.mixpanel.people.set('sessionId', data.sessionId);
    } else {
      window.mixpanel.identify(data.userId);
      window.mixpanel.people.set_once('userId', data.userId);
      window.mixpanel.people.set_once('$email', data.email);
    }

    window.mixpanel.track(data.category, mixpanelData);
    window.mixpanel.people.increment(`${data.category}::num`);
  }
};

const trackZaius = (data) => {
  if (typeof window.zaius.entity === 'function') {
    window.zaius.entity('customer', {
      customer_id: data.userId,
      email: data.email,
    });
  }

  if (typeof window.zaius.event === 'function') {
    // Send Zaius category as event
    const zaiusCategoryData = Object.assign({}, {
      action: data.category,
      customer_id: data.userId,
    });
    // Send Zaius action as event
    const zaiusActionData = Object.assign({}, {
      action: data.action,
      customer_id: data.userId,
    });
    window.zaius.event('track', zaiusCategoryData);
    window.zaius.event('track', zaiusActionData);
  }
};

// Tracking for Mixpanel and Zaius
const trackAnalytics = (category, action, standardAnalytics) => {
  if (standardAnalytics === false) {
    return;
  }

  let trackingData;
  if (!window.User.isLoggedIn) {
    // When user is not logged in, link to sessionId instead
    let sessionId;

    if (window.DocumentSettings && window.DocumentSettings.key) {
      sessionId = window.DocumentSettings.key;
    } else if (window.COOKIE.get('sessionId')) {
      sessionId = window.COOKIE.get('sessionId');
    } else {
      return;
    }

    trackingData = {
      category,
      action,
      sessionId,
    };
  } else {
    const userId = window.COOKIE.get('userid');
    const email = window.User.email;

    trackingData = {
      category,
      action,
      userId,
      email,
    };
  }

  // Make sure methods exist
  if (typeof window.mixpanel !== 'undefined') {
    trackMixpanel(trackingData);
  }

  if (typeof window.zaius !== 'undefined') {
    trackZaius(trackingData);
  }
};

window.trackOnLoggedIn = (category, action) => {
  if (window.COOKIE.get('userid')) {
    window._track(category, action);
  }
};

// Usage Tracking with Google analytics
window._track = (category, trackAction, standardAnalytics) => {
  let action = trackAction;
  const isLocalOrStagingEnv = ['local', 'staging'].includes(window.ENVIRONMENT);

  if (window.trackToConsole || isLocalOrStagingEnv) {
    console.log(`track() called with: ${category}, ${action}`);
  }
  if (category && action) {
    // documentTypes are exactly 32 letters and numbers
    const fwRegex = new RegExp(/[a-z0-9]{32}/gi);
    if (typeof (action) === 'string') {
      const documentType = action.split(' | ')[0];
      if (typeof (documentType) !== 'undefined') {
        if (fwRegex.test(documentType)) {
          // Suppress Free Write documentTypes in reporting
          const defaultFreeWriteAction = 'Custom Uploaded Doc';
          const page = action.split(' | ')[1];

          action = defaultFreeWriteAction;
          if (page) {
            action = `${defaultFreeWriteAction} | ${page}`;
          }
        }
      }
    }
  } else {
    // Nothing to track
    return;
  }
  if (typeof (gtag) !== 'undefined') {
    window.gtag('event', action, {
      event_category: category,
      send_to: window.GA_KEY,
    });
  }
  // If Mixpanel or Zaius exists, track the events
  if (typeof (window.mixpanel) !== 'undefined' || typeof (window.zaius) !== 'undefined') {
    trackAnalytics(category, action, standardAnalytics);
  }
};

window._trackSplitTestData = {
  // Gives us all the split tests & variations that the customer has seen to this point.
  // TODO: Remove this method or update to use Optimizely SDK?
  getExperIdAndVarNames: () => null,

  // Optimizely X data structure:
  // Object {2193890444: {id: "9182281268", name: "Variation #1", index: 1}

  // TODO: Remove this method or update to use Optimizely SDK?
  getDiffLastUploadToCurrData: () => {
    const currData = window._trackSplitTestData.getExperIdAndVarNames();
    if (!currData) { return null; }
    let lastUploadedData = JSON.parse(window.COOKIE.get('exp'));
    if (!lastUploadedData) {
      lastUploadedData = {};
    }

    // Get just the experiment Ids (which are the keys of that array)
    const currExperimentIds = Object.keys(currData);
    const lastExperimentIds = Object.keys(lastUploadedData);

    // Go through each of the current experiment.
    const experimentDiff = {};
    for (let i = 0; i < currExperimentIds.length; i += 1) {
      // Check if our current experiment id has been passed in already
      // If it has not, then save it to our diff array
      let variationName;
      if (lastExperimentIds.indexOf(currExperimentIds[i]) < 0) {
        if ((typeof currData[currExperimentIds[i]]) === 'object') {
          // Anticipate Optimizely X data structure and store name of variation accordingly
          variationName = currData[currExperimentIds[i]].name;
        }
        // The experiment Id was not passed in, so we save it into a diff.
        experimentDiff[`exp_${currExperimentIds[i]}`] = variationName;
      }
    }
    return experimentDiff;
  },
  saveToDB: (userId) => {
    /**
     * TODO: We should remove this tracking.
     * getExperIdAndVarNames and getDiffLastUploadToCurrData will be null,
     * because we removed Optimizely web snippet.
     * Another alternative - update `getExperIdAndVarNames` to use SDK instead of web snippet.
     */

    const dataToSend = window._trackSplitTestData.getDiffLastUploadToCurrData();
    const userToken = window.COOKIE.get('userToken');

    if (!dataToSend || !userId || !Object.keys(dataToSend).length) {
      return false;
    }

    // Post the data to server
    window.FormSwiftAPI.saveAdditionalUserData(userId, userToken, 'optimizely-experiment', dataToSend, () => {
      window.COOKIE.set('exp', JSON.stringify(window._trackSplitTestData.getExperIdAndVarNames()), 120);
    });

    return true;
  },
};

window.$_GET = {};
// Source and Split test data
window._trackSourceData = {
  keysToTrack: [
    'nonintentid',
    'u_aceid',
    'u_adgroup',
    'u_adposition',
    'u_country',
    'u_device',
    'u_landingpage',
    'u_matchtype',
    'u_network',
    'u_placement',
    'u_product',
    'u_producttype',
    'u_sitelinkid',
    'utm_advariant',
    'utm_campaign',
    'utm_campaignid',
    'utm_content',
    'utm_device',
    'utm_medium',
    'utm_placement',
    'utm_source',
    'utm_term',
  ],

  saveToCookie: () => {
    if (window.COOKIE.get('source')) {
      return;
    }
    // Fetch all GET data
    window.GET.init();

    // If we have a utm source, save all relevant data into a JSON cookie
    // &utm_source=exitpop&utm_medium=email&utm_campaign=exitpop
    if (window.$_GET.utm_source) {
      const dataToTrack = {};

      const { keysToTrack } = window._trackSourceData;
      for (let i = 0; i < keysToTrack.length; i += 1) {
        dataToTrack[keysToTrack[i]] = window.$_GET[keysToTrack[i]];
      }

      const jsonString = JSON.stringify(dataToTrack);
      window.COOKIE.set('source', jsonString, 5);
    }
  },

  saveCookieToDB: (page, userId, onSuccessCallback) => {
    const jsonString = window.COOKIE.get('source');
    const dataToTrack = JSON.parse(jsonString);
    const userToken = window.COOKIE.get('userToken');

    if (!window.COOKIE.get('source')) {
      return false;
    }

    if (!dataToTrack.utm_source || !page || !userId) {
      return false;
    }

    let callback = nullCallback;
    if (onSuccessCallback) {
      callback = onSuccessCallback;
    }

    // Post the data to server
    window.FormSwiftAPI.saveAdditionalUserData(userId, userToken, page, dataToTrack, callback);

    return true;
  },
};

window._trackAdditionalData = {
  // Do NOT pass in a nested object (i.e. { outerKey: { innerKey: innerVal }}) as data to the
  // .save() method. This will cause a failure on the api side and will result in a 500 network
  // error.
  save: (fromPage, data, onSuccessCallback) => {
    // Set our userid
    const userId = window.COOKIE.get('userid');
    const userToken = window.COOKIE.get('userToken');

    // Make sure we have data to save, and a page where the data is sent from
    // Also we have an active user.
    if (!data || typeof (data) !== 'object' || !fromPage || !userId) {
      return;
    }

    let callback = nullCallback;
    if (onSuccessCallback) {
      callback = onSuccessCallback;
    }

    // Post the data to server
    window.FormSwiftAPI.saveAdditionalUserData(userId, userToken, fromPage, data, callback);
  },
};

const isCookieCategoryAllowed = (cookieName) => {
  const cookieCategorizations = JSON.parse(window.cookieCategorizations || '{}');
  const cookieCategory = cookieCategorizations[cookieName];
  const consentPreferences = JSON.parse(window.COOKIE.get('__Secure-dbx_consent'));

  if (!consentPreferences || !consentPreferences.userInteracted) {
    return true;
  }

  const allowedCategories = consentPreferences.categories;
  return allowedCategories[cookieCategory] || false;
};

// Store cookies
window.COOKIE = {
  set: (name, value, days, extraOptions) => {
    if (!isCookieCategoryAllowed(name)) {
      return;
    }

    const options = { path: '/', ...extraOptions };
    if (days) {
      options.expires = days;
    }
    window.Cookies.set(name, value, options);
  },
  get: (name) => {
    let value = window.Cookies.get(name);
    if (value === undefined) {
      value = null;
    }
    return value;
  },
  unset: (name) => {
    window.Cookies.remove(name, { path: '/' });
  },
};

// Fetch all GET data from our URL
window.GET = {
  init: () => {
    document.location.search.replace(/\??(?:([^=]+)=([^&]*)&?)/g, (...args) => {
      const decode = s => decodeURIComponent(s.split('+').join(' '));
      const key = decode(args[1]);
      const val = decode(args[2]);

      if (key && val) {
        window.$_GET[key] = val;
      }
    });
  },
};



// WEBPACK FOOTER //
// ./src-assets/js/track-usage.js